import React from "react";

import { useImageInputContext } from "../../ImageInputContext";
import { ImageEditor } from "../ImageEditor";

import Placeholder from "../Placeholder";

/**
 * PLEASE READ
 *
 * note value prop here is a single object with image data. NOT an array of objects.
 * We are sticking to the word 'value' as opposed to something else, since this consistency
 * will be required if the ImageEditor will be rendered at some point by the card generator
 * or table generator etc.
 *
 */

export const SingleImageInput = ({
  value, // this is a subset of ImageInput's value prop
  handleDragStart
}) => {
  const {
    id,
    aspectRatio,
    onChange,
    handleUpload,
    publicUrlBeingReplaced,
    readOnly,
    enableCaptions,
    imageTags,
    invert,
    containerShape,
    defaultImageSpread,
    handleSingleImageDataChange,
    handleDeleteSingleImage,
    handleReplaceSingleImage,
    setImageUnderEdit,
    stretchToFullHeight,
    disableImageBorder,
    omitEditorTools,
    isInRTE

  } = useImageInputContext();

  //this helps for the ImageSlider, since ImageSlider uses SingleImageInput as child
  const isBeingReplaced =
    publicUrlBeingReplaced && publicUrlBeingReplaced === value?.publicUrl;

  return !value || !value.publicUrl || isBeingReplaced ? (
    <Placeholder/>
  ) : (
    <ImageEditor
      {...{
        id,
        value,
        aspectRatio,
        invert,
        containerShape,
        readOnly,
        onChange,
        enableCaptions,
        imageTags,
        defaultImageSpread,
        handleSingleImageDataChange,
        handleDeleteSingleImage,
        handleReplaceSingleImage,
        handleUpload,
        setImageUnderEdit,
        stretchToFullHeight,
        disableImageBorder,
        omitEditorTools,
        isInRTE,
        handleDragStart
      }}
    />
  );
};
